import { useMemo, useState } from 'react';
import type { BrowserTab } from '../types';

interface TabSearchProps {
  tabs: BrowserTab[];
  onSelect: (id: string) => void;
  onClose: () => void;
}

export function TabSearchModal({ tabs, onSelect, onClose }: TabSearchProps) {
  const [query, setQuery] = useState('');
  const filtered = useMemo(() => tabs.filter((tab) => `${tab.title} ${tab.url}`.toLowerCase().includes(query.toLowerCase())), [tabs, query]);
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <section className="modal" onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true">
        <header><h2>Search tabs</h2><button onClick={onClose}>×</button></header>
        <input autoFocus value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Find open tabs" />
        <div className="list-card compact">
          {filtered.map((tab) => <button key={tab.id} className="tab-search-row" onClick={() => { onSelect(tab.id); onClose(); }}><img className="favicon" src={tab.favicon || '/icons/mark-circle.png'} alt="" /><span>{tab.title}</span><small>{tab.displayUrl}</small></button>)}
        </div>
      </section>
    </div>
  );
}

interface ToastProps { message: string; onClose: () => void; }
export function Toast({ message, onClose }: ToastProps) {
  if (!message) return null;
  return <div className="toast" role="status"><span>{message}</span><button onClick={onClose}>×</button></div>;
}
